import { Badge } from "@tellescope/design-system";

interface PriceBadgeProps {
  label: string;
  className?: string;
}

/** Price badge — always uses --primary-readable so it stays legible on a pale primary. */
export const PriceBadge = ({ label, className }: PriceBadgeProps) => (
  <Badge
    className={className}
    style={{ backgroundColor: "hsl(var(--primary) / 0.1)", color: "hsl(var(--primary-readable))" }}
  >
    {label}
  </Badge>
);
